/* istanbul ignore file */
/* tslint:disable */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CreateGroupGroupSetData, ExtendedGroup, GroupSet } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function groupSet(config) {
    const createGroupResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(ExtendedGroup)),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(GroupSet)),
    });
    const getAllGroupsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(ExtendedGroup))),
    });
    return Object.freeze({
        /**
         * Create a group for the given group set.
         *
         * @param arg The arguments to the function.
         * @param arg.groupSetId The id of the group set where the new group should be placed in.
         * @param arg.requestBody The body of the request.
         * @returns The newly created group.
         */
        createGroup: async ({ groupSetId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/group_sets/${groupSetId}/group`, createGroupResponse.v, JSON.stringify(CreateGroupGroupSetData.encode(requestBody)));
            return result;
        },
        /**
         * Delete a `GroupSet`.
         *
         * You can only delete a group set if there are no groups in the set and no assignment is connected to the group set.
         *
         * @param arg The arguments to the function.
         * @param arg.groupSetId The id of the group set
         * @returns Nothing.
         */
        delete: async ({ groupSetId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/group_sets/${groupSetId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get a single `GroupSet` by id.
         *
         * @param arg The arguments to the function.
         * @param arg.groupSetId The id of the group set
         * @returns A response containing the JSON serialized group set.
         */
        get: async ({ groupSetId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/group_sets/${groupSetId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Get all groups for a given group set.
         *
         * @param arg The arguments to the function.
         * @param arg.groupSetId The group set for which the groups should be returned.
         * @returns All the groups for the given group set.
         */
        getAllGroups: async ({ groupSetId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/group_sets/${groupSetId}/groups/`, getAllGroupsResponse.v, undefined);
            return result;
        },
    });
}
